import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Close Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?type=design&node-id=572-9023&mode=design&t=vxPXDw86hpJ6KW32-4)
 * */

const CloseIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g className="stroke-current" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#close-icon-path)"><path d="M1 11 11 1M11 11 1 1" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="close-icon-path"><path fill="#fff" d="M0 0h12v12H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CloseIcon;